import React from 'react';

import PropTypes from 'prop-types';

import { ReactComponent as SpecialsIcon } from 'assets/svg/specials.svg';

const SpecialsBadge = ({ className, label }) => (
  <div className={className}>
    <SpecialsIcon className="w-3 h-3 text-white fill-current" />
    <p className="font-primary font-medium text-3.5 leading-4 -tracking-0.4 text-white">{label}</p>
  </div>
);

SpecialsBadge.defaultProps = {
  className: 'flex h-6 items-center justify-center gap-1 bg-primary px-1 rounded',
  label: 'Specials',
};

SpecialsBadge.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
};

export default SpecialsBadge;
